import { InputAPI, ModalButton, ModalProps, ModalService } from '@philips-internal/oswald-ui-components';
import { ModalButtonType, ModalType } from '@philips-internal/oswald-ui-constants';
import { FragmentNames } from '../../../codegen';
import { generateUUID } from '@philips-internal/oswald-ui-utils';

export default class ValidateTypeScale {
  static valdiate(scalePainSelected: string, inputApi: InputAPI): void {
    const acceptedTypes: Record<string, (inputPainScaleApi: InputAPI)=>void> = {
      BPS(inputPainScaleApi: InputAPI) {
        const dialogModal: ModalProps = {
          closeByDocument: false,
          closeByEscape: false,
          contextData: {
            setPainScaleValue: (painScaleValue: number): void => {
              inputPainScaleApi.setValue(painScaleValue);
            }
          },
          focusOnOpen: false,
          fragment: 'modified-pain-behavioral',
          id: 'modified-pain-behavioral',
          type: ModalType.FULLSCREEN,
          uuid: generateUUID(),
        };

        ModalService.openDefault(dialogModal);
      },
      CPOT(inputPainScaleApi: InputAPI) {
        const dialogModal: ModalProps = {
          closeByDocument: false,
          closeByEscape: false,
          contextData: {
            setPainScaleValue: (painScaleValue: number): void => {
              inputPainScaleApi.setValue(painScaleValue);
            }
          },
          focusOnOpen: false,
          fragment: FragmentNames.CPOT_PAIN_SCALE,
          id: FragmentNames.CPOT_PAIN_SCALE,
          type: ModalType.FULLSCREEN,
          uuid: generateUUID(),
        };

        ModalService.openDefault(dialogModal);
      },
      CRIES(inputPainScaleApi: InputAPI) {
        const dialogModal: ModalProps = {
          closeByDocument: false,
          closeByEscape: false,
          contextData: {
            setPainScaleValue: (painScaleValue: number): void => {
              inputPainScaleApi.setValue(painScaleValue);
            }
          },
          focusOnOpen: false,
          fragment: 'cries-pain-scale',
          id: 'cries-pain-scale',
          type: ModalType.FULLSCREEN,
          uuid: generateUUID(),
        };

        ModalService.openDefault(dialogModal);
      },
      CV(inputPainScaleApi: InputAPI) {
        const dialogModal: ModalProps = {
          closeByDocument: false,
          closeByEscape: false,
          contextData: {
            setPainScaleValue: (painScaleValue: number): void => {
              inputPainScaleApi.setValue(painScaleValue);
            }
          },
          focusOnOpen: false,
          fragment: 'vital-sign-pain-scale-field',
          id: 'vital-sign-pain-scale-field',
          type: ModalType.FULLSCREEN,
          uuid: generateUUID(),
        };

        ModalService.openDefault(dialogModal);
      },
      ECD(inputPainScaleApi: InputAPI) {
        const dialogModal: ModalProps = {
          closeByDocument: false,
          closeByEscape: false,
          contextData: {
            setPainScaleValue: (painScaleValue: number): void => {
              inputPainScaleApi.setValue(painScaleValue);
            }
          },
          focusOnOpen: false,
          fragment: 'behavior-pain-scale',
          id: 'behavior-pain-scale',
          type: ModalType.FULLSCREEN,
          uuid: generateUUID(),
        };

        ModalService.openDefault(dialogModal);
      },
      FACES(inputPainScaleApi: InputAPI) {
        let isCancel = false;
        const buttons: ModalButton[] = [
          {
            action: () => { isCancel = true },
            enabled: true,
            title: 'tws.biometry.cancel',
            type: ModalButtonType.CANCEL,
          },
          {
            action: () => {
              isCancel = false;
              ModalService.close('adapted-faces-pain-scale')
            },
            enabled: true,
            title: 'tws.filter.apply',
            type: ModalButtonType.SUCCESS,
          },
        ];

        const dialogModal: ModalProps = {
          closeByDocument: false,
          closeByEscape: false,
          contextData: {
            setPainScaleValue: (painScaleValue: number): void => {
              inputPainScaleApi.setValue(isCancel ? 0 : painScaleValue);
            }
          },
          dockButtons: buttons,
          focusOnOpen: false,
          fragment: 'adapted-faces-pain-scale',
          id: 'adapted-faces-pain-scale',
          type: ModalType.FULLSCREEN,
          uuid: generateUUID(),
        };

        ModalService.openDefault(dialogModal);
      },
      FEVA(inputPainScaleApi: InputAPI) {
        const buttons: ModalButton[] = [
          {
            action: () => { },
            enabled: true,
            title: 'tws.biometry.cancel',
            type: ModalButtonType.CANCEL,
          },
          {
            action: () => ModalService.close('analogic-faces-pain-scale'),
            enabled: true,
            title: 'tws.filter.apply',
            type: ModalButtonType.SUCCESS,
          },
        ];

        const dialogModal: ModalProps = {
          closeByDocument: false,
          closeByEscape: false,
          contextData: {
            setPainScaleValue: (painScaleValue: number): void => {
              inputPainScaleApi.setValue(painScaleValue);
            }
          },
          dockButtons: buttons,
          focusOnOpen: false,
          fragment: FragmentNames.ANALOGIC_FACES_PAIN_SCALE,
          id: FragmentNames.ANALOGIC_FACES_PAIN_SCALE,
          type: ModalType.FULLSCREEN,
          uuid: generateUUID(),
        };

        ModalService.openDefault(dialogModal);
      },
      FLACC(inputPainScaleApi: InputAPI) {
        const dialogModal: ModalProps = {
          closeByDocument: false,
          closeByEscape: false,
          contextData: {
            setPainScaleValue: (painScaleValue: number): void => {
              inputPainScaleApi.setValue(painScaleValue);
            }
          },
          focusOnOpen: false,
          fragment: 'flacc-pain-scale',
          id: 'flacc-pain-scale',
          type: ModalType.FULLSCREEN,
          uuid: generateUUID(),
        };

        ModalService.openDefault(dialogModal);
      },
      MOPS(inputPainScaleApi: InputAPI) {
        const dialogModal: ModalProps = {
          closeByDocument: false,
          closeByEscape: false,
          contextData: {
            setPainScaleValue: (painScaleValue: number): void => {
              inputPainScaleApi.setValue(painScaleValue);
            }
          },
          focusOnOpen: false,
          fragment: FragmentNames.MOPS_PAIN_SCALE,
          id: FragmentNames.MOPS_PAIN_SCALE,
          type: ModalType.FULLSCREEN,
          uuid: generateUUID(),
        };

        ModalService.openDefault(dialogModal);
      },
      MS(inputPainScaleApi: InputAPI) {
        const buttons: ModalButton[] = [
          {
            action: () => { },
            enabled: true,
            title: 'tws.biometry.cancel',
            type: ModalButtonType.CANCEL,
          },
          {
            action: () => ModalService.close(FragmentNames.LIGHT_FACES_PAIN_SCALE),
            enabled: true,
            title: 'tws.filter.apply',
            type: ModalButtonType.SUCCESS,
          },
        ];

        const dialogModal: ModalProps = {
          closeByDocument: false,
          closeByEscape: false,
          contextData: {
            setPainScaleValue: (painScaleValue: number): void => {
              inputPainScaleApi.setValue(painScaleValue);
            }
          },
          dockButtons: buttons,
          focusOnOpen: false,
          fragment: FragmentNames.LIGHT_FACES_PAIN_SCALE,
          id: FragmentNames.LIGHT_FACES_PAIN_SCALE,
          type: ModalType.FULLSCREEN,
          uuid: generateUUID(),
        };

        ModalService.openDefault(dialogModal);
      },

      NFCS(inputPainScaleApi: InputAPI) {
        const dialogModal: ModalProps = {
          closeByDocument: false,
          closeByEscape: false,
          contextData: {
            setPainScaleValue: (painScaleValue: number): void => {
              inputPainScaleApi.setValue(painScaleValue);
            }
          },
          focusOnOpen: false,
          fragment: FragmentNames.NFCS_PAIN_SCALE,
          id: FragmentNames.NFCS_PAIN_SCALE,
          uuid: generateUUID(),
        };
        ModalService.openDefault(dialogModal);
      },
      NIPS(inputPainScaleApi: InputAPI) {
        const dialogModal: ModalProps = {
          closeByDocument: false,
          closeByEscape: false,
          contextData: {
            setPainScaleValue: (painScaleValue: number): void => {
              inputPainScaleApi.setValue(painScaleValue);
            }
          },
          focusOnOpen: false,
          fragment: FragmentNames.NIPS_PAIN_SCALE,
          id: FragmentNames.NIPS_PAIN_SCALE,
          uuid: generateUUID(),
        };
        ModalService.openDefault(dialogModal);
      },
      PD(inputPainScaleApi: InputAPI) {
        const dialogModal: ModalProps = {
          closeByDocument: false,
          closeByEscape: false,
          contextData: {
            setPainScaleValue: (painScaleValue: number): void => {
              inputPainScaleApi.setValue(painScaleValue);
            }
          },
          focusOnOpen: false,
          fragment: FragmentNames.PD_PAIN_SCALE,
          id: FragmentNames.PD_PAIN_SCALE,
          type: ModalType.FULLSCREEN,
          uuid: generateUUID(),
        };
        ModalService.openDefault(dialogModal);
      },
    };

    const typeScalePainFunction = acceptedTypes[scalePainSelected];

    if(typeScalePainFunction){
      typeScalePainFunction(inputApi);
    }
  }
}